import { Component, Inject } from '@angular/core';
import { UiService } from 'src/app/services/ui.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiAppData } from 'globals/store/app.data';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { DialogWrapperComponent } from '../../wrappers/dialog-wrapper.component';
import { DeleteButtonComponent } from '../../buttons/delete-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-manage-apps-component',
    template: `
<dialog-wrapper
  [dialogTitle]="'Manage Apps'"
  [smallTitle]="true"
  [titleHeight]="40"
  [hideBottom]="true"
  [showClose]="true"
  (close)="dialogRef.close(data)">
  <h3>Remove event from home screen</h3>
  <div class="app" *ngFor="let appData of data; first as first" [class.first]="first">
    <div class="title">{{ appData.title }}</div>
    <delete-button [deleteTitle]="deleteTitle" [deleteText]="deleteText" [deleteButtonText]="'REMOVE'" (delete)="deleteApp(appData)"></delete-button>
  </div>
</dialog-wrapper>
  `,
    styleUrls: ['./mobile-manage-apps.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, DeleteButtonComponent, CommonModule]
})


export class MobileManageAppsComponent extends MobileAppWrapper<MobileManageAppsComponent> {
  deleteTitle = 'Remove event'
  deleteText = 'Are you sure you want to remove this event from your phone?'

  constructor(
    public dialogRef:MatDialogRef<MobileManageAppsComponent>,
    public uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: JoiAppData[],
  ) {
    super()
  }
  
  deleteApp(appData: JoiAppData) {
    this.data = this.data.filter(a => a.publishCode !== appData.publishCode)
    this.mobileAppService.saveAppDatas(this.data)
  }

}

